import React, { useState } from "react";
import LoadingSpinner from "../../../../components/LoadingSpinner";
import axios from "axios";
import { ApiConnectionString } from "../../../../constants/ApiConntection";
import { useAuthContext } from "../../../../hooks/useAuthContext";

export default function DeleteCouponModal({ selectedCouponId, cancelModal }) {
  const [isLoading, setIsLoading] = useState(false);
  const [deleteComplete, setDeleteComplete] = useState(false);
  const { user } = useAuthContext();

  const handleClick = async () => {
    setIsLoading(true);
    try {
      const deleteResponse = await axios.delete(
        `${ApiConnectionString}/api/Coupon/${selectedCouponId}`,
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );

      if (deleteResponse.status === 200) {
        setDeleteComplete(true);
      }
    } catch (error) {
      console.error("Delete failed:", error);
      // Optional: Handle the error (e.g. show an error message)
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return (
      <div className="send-modal-overlay">
        <div className="send-modal">
          <LoadingSpinner />
        </div>
      </div>
    );
  } else {
    if (deleteComplete) {
      return (
        <div className="send-modal-overlay">
          <div className="send-modal">
            <div className="blueBanner">
              <p className="fw-bold m-2 p-2 fontSize20">Delete Coupon</p>
            </div>

            <button
              type="button"
              className="close-button"
              onClick={cancelModal}
              aria-label="Close"
            >
              &times;
            </button>
            <p>The coupon was successfully deleted.</p>

            <div className="send-modal-footer">
              <button
                onClick={cancelModal}
                className="pointer cancelButton fw-bold mx-2 px-3"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div className="send-modal-overlay">
          <div className="send-modal">
            <div className="blueBanner">
              <p className="fw-bold m-2 p-2 fontSize20">Delete Coupon</p>
            </div>

            <button
              type="button"
              className="close-button"
              onClick={cancelModal}
              aria-label="Close"
            >
              &times;
            </button>
            <div>
              <p>Are you sure you want to delete this coupon?</p>
            </div>
            <div className="send-modal-footer">
              <button className="delete-button mx-3" onClick={handleClick}>
                Confirm
              </button>
              <button
                onClick={cancelModal}
                className="pointer cancelButton fw-bold mx-2 px-3"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      );
    }
  }
}
